import { Controller } from "@hotwired/stimulus"

// One-time reveal modal for API keys. Reads the plaintext token from the
// markup, copies it to the clipboard, and briefly swaps the button label
// to "Copied" for visual confirmation. The token is never re-fetched
// from the server — once this page is left, the plaintext is gone.
export default class extends Controller {
	static targets = ["token", "copyButton"]

	async copy() {
		const text = this.tokenTarget.textContent.trim()
		try {
			await navigator.clipboard.writeText(text)
		} catch (_e) {
			// Older browsers / insecure contexts: fall back to a manual selection.
			this.#selectFallback(text)
		}

		const button = this.copyButtonTarget
		const original = button.dataset.copyLabel
		const copied = button.dataset.copiedLabel
		const labelEl = button.querySelector("span:last-child") || button
		labelEl.textContent = copied
		setTimeout(() => {
			labelEl.textContent = original
		}, 2000)
	}

	#selectFallback(_text) {
		const range = document.createRange()
		range.selectNode(this.tokenTarget)
		const selection = window.getSelection()
		selection.removeAllRanges()
		selection.addRange(range)
	}
}
